<div class="material-page">
  
  <div *ngIf="itemToSell">
    <div class="mdc-layout-grid">
      <div class="mdc-layout-grid__inner">
        <div class="left mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
          <div>
            <h1>{{itemToSell.title}}</h1>
            <p>{{itemToSell.description}}</p>
          </div>
          <div style="display: flex; align-items: center;">
            <h1 class="mat-headline-1" style="margin-right: 16px; margin-bottom: 0px;"><font class="with-stripe"><b>1</b></font></h1>
            <h1 class="mat-headline-4" style="margin-bottom: 0px;" i18n>Add picture(s)</h1>
          </div>
          <image-list-editor [pictures]="itemToSell.pictures" (onChange)="numberOfPicturesChanged()"></image-list-editor>
        </div>
      </div>
    </div>
    
    <mat-divider></mat-divider>
    
    <form (ngSubmit)="preview()" [formGroup]="listingForm">
      <div class="mdc-layout-grid">
        <div class="mdc-layout-grid__inner">
          <div class="left mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
            <div style="display: flex; align-items: center;">
              <h1 class="mat-headline-1" style="margin-right: 16px; margin-bottom: 0px;"><font class="with-stripe"><b>2</b></font></h1>
              <h1 class="mat-headline-4" style="margin-bottom: 0px;" i18n>Tell us the current condition of the item</h1>
            </div>
            <mat-radio-group class="radio-group" formControlName="condition" required>
              <mat-radio-button value="1" i18n>New</mat-radio-button>
              <mat-radio-button value="2" i18n>Used - like new / open box</mat-radio-button>
              <mat-radio-button value="3" i18n>Used - very good</mat-radio-button>
              <mat-radio-button value="4" i18n>Used - good</mat-radio-button>
              <mat-radio-button value="5" i18n>Used - fair</mat-radio-button>
              <mat-radio-button value="6" i18n>Used - poor / for parts or not working</mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="listingForm.controls['condition'].touched && listingForm.controls['condition'].errors?.['required']"
                i18n="error when user tries to create listing without selecting condition">Select condition</mat-error>
          </div>
          <div class="left mdc-layout-grid__cell mdc-layout-grid__cell--span-4">
            <div style="display: flex; align-items: center;">
              <h1 class="mat-headline-1" style="margin-right: 16px; margin-bottom: 0px;"><font class="with-stripe"><b>3</b></font></h1>
              <h1 class="mat-headline-4" style="margin-bottom: 0px;" i18n>Set the price</h1>
            </div>
            <mat-form-field style="width: 100%; max-width: 150px;">
              <input matInput formControlName="price" type="number" required>
              <span matTextPrefix>€</span>
              <mat-error *ngIf="listingForm.controls['price'].errors?.['required']"
                  i18n="error when user tries to create listing without price">Price is missing</mat-error>
            </mat-form-field>
          </div>
          <div class="left mdc-layout-grid__cell mdc-layout-grid__cell--span-4">
            <mat-card *ngIf="itemToSell.purchasePriceEUR">
              <mat-card-header>
                <div mat-card-avatar>
                  <mat-icon style="width: 48px; height: 48px; font-size: 48px;" fontSet="material-symbols-outlined">sell</mat-icon>
                </div>
              </mat-card-header>
              <mat-card-content i18n>You paid <b>{{itemToSell.purchasePriceEUR!.toNumber() | currency : itemToSell.purchasePriceEUR!.currency()}}</b> for the item on {{itemToSell.dateOfPurchase | date}}</mat-card-content>
            </mat-card>
          </div>
        </div>
      </div>
    
      <mat-divider></mat-divider>
    
      <div class="button-panel">
        <button 
            mat-raised-button 
            type="submit" 
            color="accent" 
            angulartics2On="click" 
            angularticsAction="NextClick"
            [angularticsCategory]="'' + itemToSell.id"
            >
            
          <mat-icon fontSet="material-symbols-outlined">store</mat-icon>
          <ng-container i18n="create listing next button label">NEXT</ng-container>
        </button>
        <button mat-button type='button' (click)="toItemList()" i18n="button label">
          DON'T LIST
        </button>
      </div>
    </form>
  </div>
</div>